import { Col, Row } from 'antd';
import { Typography } from 'antd';
import PricingPage from 'app/components/Pricing/PricingPage';
import React from 'react';

import HeaderFullLogo from '../../../assets/appIcons/header-full-logo-purple.svg';
import V1DashBoard from '../../../assets/onboarding/v1-db.svg';
// style
import './pricing.style.scss';

const { Title, Paragraph } = Typography;

const Pricing = () => {
  // component
  return (
    <div className="login-container">
      <Row className="login-wrapper">
        <Col xs={24} sm={24} md={10} lg={10} xl={12}>
          <div
            style={{
              display: 'flex',
              flex: 1,
              flexDirection: 'column',
              height: '100%',
            }}
          >
            <div
              style={{
                width: '50%',
                flexDirection: 'column',
                marginTop: 70,
                marginBottom: 70,
                alignSelf: 'center',
              }}
            >
              <Title
                style={{
                  fontWeight: 'bold',
                  textAlign: 'center',
                  width: '90%',
                }}
                level={1}
              >
                Plans that Scale with Your Supply Chain
              </Title>
              <Paragraph
                style={{
                  textAlign: 'center',
                }}
              >
                Beebolt gives your team the power to streamline logistics,
                collaborate seamlessly, and track global shipments—all in one
                place. Choose the plan that fits your operation and start
                optimizing today.
              </Paragraph>
            </div>
            <img src={V1DashBoard} alt="dashboard" style={{ width: '90%' }} />
          </div>
        </Col>
        <Col xs={24} sm={24} md={14} lg={14} xl={12}>
          <div className="stripe-wrapper">
            <PricingPage />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Pricing;
